import _filter from "ramda/es/filter";
import _lt from "ramda/es/lt";
import _pipe from "ramda/es/pipe";

var filterLt = _pipe(_lt, _filter);

export default filterLt;